import { UseNewsletterEmailPrefillParams } from "@model/Home.model";
import { useEffect, useRef } from "react";



export function useNewsletterEmailPrefill({
  isLoggedIn,
  authEmail,
  setEmail,
  setApiError,
  setSuccessMsg,
}: UseNewsletterEmailPrefillParams) {
  const userEditedRef = useRef(false);
  const didPrefillRef = useRef(false);

  useEffect(() => {
    if (!isLoggedIn) return;

    const cleanEmail = String(authEmail || "").trim();
    if (!cleanEmail) return;

    if (didPrefillRef.current) return;
    if (userEditedRef.current) return;

    setEmail(cleanEmail);
    didPrefillRef.current = true;
  }, [isLoggedIn, authEmail, setEmail]);

  const handleChange = (value: string) => {
    userEditedRef.current = true;
    setEmail(value);

    if (setApiError) setApiError(null);
    if (setSuccessMsg) setSuccessMsg(null);
  };

  const resetPrefillGuards = () => {
    userEditedRef.current = false;
    didPrefillRef.current = false;
  };

  return { handleChange, resetPrefillGuards };
}
